import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-tablet" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-take-pic" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-take-pic" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-take-pic" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-videocam" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image-cd" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-file-cd" }, null, -1)
const _hoisted_8 = {
  key: 4,
  for: "fileInput"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createBlock(_component_app_bottom_pop_up, {
        key: 0,
        onHide: _ctx.hidePopUp,
        "hide-bottom-decoration": "",
        "hide-top-decoration": ""
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$localize('message.add.menu.popup.title')), 1)
        ]),
        body: _withCtx(() => [
          _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.openCase }, {
            icon: _withCtx(() => [
              _hoisted_1
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('message.add.menu.popup.case')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          (!_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
            ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openTakePhoto(false)))
              }, {
                icon: _withCtx(() => [
                  _hoisted_2
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$localize('message.add.menu.popup.takephoto')) + " ", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
            ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                key: 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openTakePhoto(_ctx.CHOOSER_TYPE.CAMERA_IMAGE)))
              }, {
                icon: _withCtx(() => [
                  _hoisted_3
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$localize('message.add.menu.popup.camera.image')) + " ", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.mainStore.isFlutter)
            ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                key: 2,
                onClick: _ctx.openCamera,
                "data-type": "flutter"
              }, {
                icon: _withCtx(() => [
                  _hoisted_4
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$localize('message.add.menu.popup.takephoto')) + " ", 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
            ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                key: 3,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openTakePhoto(_ctx.CHOOSER_TYPE.CAMERA_VIDEO)))
              }, {
                icon: _withCtx(() => [
                  _hoisted_5
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$localize('message.add.menu.popup.camera.video')) + " ", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.openDriveMedia }, {
            icon: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('message.photo.selector.popup.casedrive')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.openFileList }, {
            icon: _withCtx(() => [
              _hoisted_7
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$localize('message.file.selector.popup.casedrive')) + " ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          (!_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
            ? (_openBlock(), _createElementBlock("label", _hoisted_8, [
                _createVNode(_component_bottom_pop_up_item, null, {
                  icon: _withCtx(() => [
                    _hoisted_9
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('message.file.selector.popup.upload.files')) + " ", 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
            ? (_openBlock(), _createElementBlock("label", {
                key: 5,
                for: "fileInput",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.GALLERY)))
              }, [
                _createVNode(_component_bottom_pop_up_item, null, {
                  icon: _withCtx(() => [
                    _hoisted_10
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('message.file.selector.popup.upload.gallery')) + " ", 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.mainStore.isFlutter)
            ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                key: 6,
                onClick: _ctx.openImagePicker,
                "data-type": "flutter"
              }, {
                icon: _withCtx(() => [
                  _hoisted_11
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$localize('message.file.selector.popup.upload.gallery')) + " ", 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
            ? (_openBlock(), _createElementBlock("label", {
                key: 7,
                for: "fileInput",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.FILE)))
              }, [
                _createVNode(_component_bottom_pop_up_item, null, {
                  icon: _withCtx(() => [
                    _hoisted_12
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('message.file.selector.popup.upload.files')) + " ", 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("input", {
            onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.uploadFile($event))),
            id: "fileInput",
            ref: "fileInput",
            style: {"visibility":"hidden"},
            type: "file"
          }, null, 544), [
            [_vShow, false]
          ]),
          (_ctx.mainStore.isFlutter)
            ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
                key: 8,
                onClick: _ctx.openFilePicker,
                "data-type": "flutter"
              }, {
                icon: _withCtx(() => [
                  _hoisted_13
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$localize('message.file.selector.popup.upload.files')) + " ", 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onHide"]))
    : _createCommentVNode("", true)
}